import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-links">
          <a href="https://navigationalmind.com" target="_blank" rel="noopener noreferrer">
            NMA Clarity
          </a>
          <a href="https://navigationalfidelity.com" target="_blank" rel="noopener noreferrer">
            Truth Engine
          </a>
          <a href="https://drtoye.ca" target="_blank" rel="noopener noreferrer">
            Navigation Compasses
          </a>
          <a href="https://navigational-mind-6fnpsq.jellypod.ai" target="_blank" rel="noopener noreferrer">
            Podcast
          </a>
        </div>
        <p className="footer-credit">
          The Navigational Mind Framework by{' '}
          <a href="https://drtoye.ca" target="_blank" rel="noopener noreferrer">
            Dr. Toye Oyelese
          </a>
          {' '}• Clinical Associate Professor, UBC Faculty of Medicine
        </p>
      </div>
    </footer>
  );
}

export default Footer;
